<div class="d-flex zone" [ngClass]="{'disabledDiv': (maxPersonAmount != 0 && maxPersonAmount != undefined && dossierPersonsAmount >= maxPersonAmount), 'zone-noitem': dossierPersonsAmount === 0 }">
    <div class="align-items-center m-auto justify-content-center text-center">
        <i class="d-none d-lg-block bi bi-person-plus actionIcon" aria-hidden="true"></i>
        <div class="dropdown">
            <button class="btn btn-sm btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" translate>Button.AddPersons</button>
            <div class="dropdown">
                <ul class="dropdown-menu w-auto">
                    <li><a class="person" (click)="addMyself()" *ngIf="showAddMyself" ngbDropdownItem translate>Button.AddMyself</a></li>
                    <li><a class="person" (click)="addPerson()" ngbDropdownItem translate>Button.AddPerson</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>
